import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import { VoucherCodeLightBoxHeader } from './voucher_code_light_box_header';
import { VoucherCodeLightBoxContent } from './voucher_code_light_box_content';

function VoucherCodeLightBox(props) {
    const isNRMA = TYROOLA.globals.store === 'AU_NRMA';
    return (
        <Lightbox
            opened={props.visible}
            onClose={props.onClose}
            additionalClassNames={['voucher-code-light-box__lightbox']}
            headerIcon={`${isNRMA ? 'icon--nrma-navy' : 'icon--wheel-alignment'}`}

        >
            <div className="cross-sell-remove-light-box" style={{ maxWidth: '640px' }}>
                <VoucherCodeLightBoxHeader data={props.data} />
                <VoucherCodeLightBoxContent
                    data={props.data}
                    code={props.code}
                    loading={props.loading}
                    error={props.error}
                    onRedeem={props.onRedeem}
                    onClose={props.onClose}
                />
            </div>
        </Lightbox>
    );
}

VoucherCodeLightBox.propTypes = {
    visible: PropTypes.bool.isRequired,
    error: PropTypes.object,
    onRedeem: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { VoucherCodeLightBox };
